export const es = {
    invalidLinkTitle: `Enlace de restablecimiento inválido`,
    invalidLinkDescription: `Este enlace de restablecimiento es inválido o ha expirado`,
    invalidToken: `Token de restablecimiento inválido o ausente. Por favor solicita un nuevo restablecimiento de contraseña.`,
    requestNewReset: `Solicitar nuevo restablecimiento`,
    title: `Restablecer contraseña`,
    description: `Ingresa tu nueva contraseña para {email}`,
    success: `¡Contraseña restablecida con éxito! Ahora puedes iniciar sesión con tu nueva contraseña.`,
    redirect: `Serás redirigido a la página de inicio de sesión en {count} segundos...`,
    continueNow: `Continuar para iniciar sesión ahora`,
    resetPasswordButton: `Restablecer contraseña`,
    failure: `El restablecimiento de contraseña falló. Por favor inténtalo de nuevo.`,
};
//# sourceMappingURL=es.js.map